
export function SelectTypeValidatorDropZone(typeValidator: string) {

    const ValidatorType: any = {
        ONLY_IMAGE: {accept: {'image/jpeg': [], 'image/png': [], 'image/jpg': []}, multiple: false, maxSize:1000000},
        ONLY_JSON: {accept: {'application/json': []}, multiple: false, maxSize:1000000}
    };
    
    return ValidatorType[typeValidator];
}